var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.avaliacao)?_c('v-btn',{staticClass:"mt-3 normal-btn-text rounded-tag-small elevation-0",attrs:{"link":"","to":("/avaliacao/" + (_vm.avaliacao.key)),"color":"primary","min-width":"171px"}},[_vm._v(" Avaliar compra ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }